import React, { useEffect, useState} from "react";
import store from "@/redux/store";

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'

import { Detail as CustomerCompany } from "@/views/base/company/Detail";
import { Storage } from "@/views/Tenant/Storage";
import { useForm, SubmitHandler } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";
import {FieldHolder} from "@/components/holders/FieldHolder";
import { useNavigate, Link } from "react-router-dom";
import {Sectors} from '@/views/Tenant/Sectors';

import { open, close, setPos } from '@/reducers/Window'
import { updateDropbox } from '@/reducers/Tenant'
import {WINDOW} from "@/actions/globalConst";


export function Detail({...props}) {
  const {subscribe, register, handleSubmit, watch, reset,    formState, setValue, getValues } = useForm({
      defaultValues: props.selected,
        resetOptions: {
    keepDirtyValues: true, // user-interacted input will be retained
    keepErrors: true, // input errors will be retained with value update
  }
      //values: props.data
    })
//    console.debug("console.debug( props?.selected", props.data.ppc_tenant_fields )
    
//setValue('tenant.fields.DROPBOX.baseMap', 'sfd');
    const [dropbox, setDropbox] = useState({...props.data?.fields?.DROPBOX})
    const [selectedTab, setSelectedTab] = useState(1)
const tabs = [
  {tabId: 1, name: 'Basis gegevens', href: '#', icon: UserIcon, current: true },
  {tabId: 3, name: 'Sectoren', href: '#', icon: UserIcon, current: true },
]  // More people...


if(dropbox.state >= 5) {
    tabs.push({tabId: 2, name: 'Dropbox', href: '#', icon: UserIcon, current: true })
}
const setTab = (tabId) => {
    setSelectedTab(tabId);
}
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const openDropboxConnectWindow = () => {
    store.dispatch( open({...WINDOW.DROPBOX_CONNECT, data: dropbox, setBaseMapEvent: setBaseMapEventHandler}) );
    return false;    
}

const setBaseMapEventHandler = (baseMap) => {
    dropbox.baseMap = baseMap;
    setDropbox(dropbox);
    
    
    store.dispatch( updateDropbox({tenantKey: props.data?.key, data:dropbox}) );
    
    
}
   const onSubmit: SubmitHandler<any> = (data) => {
    let newData = getValues(undefined, { touchedFields: true});
    newData.key = data.key;
    if(props?.onSaveHandler) {
      
        props.onSaveHandler(newData);
    }
      
    return false;

    }
 
 
   return (
    <>

    <div className="space-y-1 divide-y divide-gray-900/10">
      <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">
       <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSubmit)}>
       
       {dropbox.state == 1 &&
       
    <div className="rounded-md bg-yellow-50 p-4">
      <div className="flex">
        <div className="shrink-0">
      <svg className="size-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
        <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clipRule="evenodd" />
      </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">Dropbox</h3>
          <div className="mt-2 text-sm text-yellow-700">
            <p>Dropbox is momenteel de gegevens aan het ophalen.. moment geduld.</p>
          </div>
        </div>
      </div>
    </div>        
       }

    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          defaultValue={tabs.find((tab) => tab.current).name}
          className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <a
                key={tab.name}
                href={tab.href}
                onClick={() => setTab(tab.tabId)}
                aria-current={tab.tabId == selectedTab ? 'page' : undefined}
                className={classNames(
                  tab.tabId == selectedTab
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                  'group inline-flex items-center border-b-2 px-1 py-4 text-sm font-medium',
                )}
              >
                <span>{tab.name}</span>
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>       
       
          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to="../" type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>

        <div>




        </div>
          <div className="px-4 py-2 sm:p-8">
            <div className="mt-1 space-y-8 pb-12 sm:space-y-0   sm:pb-0">
                  <input
                    id="key"
                    name="key"
                    type="hidden"
                    {...register("key")}
                    key={(props.data && props.data.key) ?? null} />
                {selectedTab == 1 &&
                <CustomerCompany {...props} register={register}  data={props.data} registerkey="" externTenants={((props?.externTenants) ? props?.externTenants : [])} getValues={getValues} setFormValues={setValue}/>
                }
                {selectedTab == 3 &&
                <Sectors data={props.tenant.fields} tenants={props?.tenants} selectedTenant={props?.tenant} register={register} registerkey="SECTORS" getValuess={getValues} setFormValues={setValue}/> 
                }
                {selectedTab == 2 &&
                <Storage data={props.data.tenant.fields} register={register} registerkey="DROPBOX" getValuess={getValues} setFormValues={setValue}/>
                }
                </div>
          </div>
          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to="../" type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
            <button
              onClick={() => openDropboxConnectWindow()}
              type="button"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Connect
            </button>
            
            
          </div>
        
        </form>
      </div>
      </div>


    </>
    )   
}